// Visual separator. Partners use these between section headers + tables.
export function DividerBlockView() {
  return <hr className="border-border" />
}
